export function isNodeList(el) {
  // Only NodeList has the "item()" function
  return typeof el.item !== "undefined"; 
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/isNodeList.js
// module id = 492
// module chunks = 2